declare namespace $ {

	export class $mol_icon_heart extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=heart.view.tree.d.ts.map